import { getEndpoint } from "@api-routes/endpoint";

const BILLING_MS_NAME = "billing";
export const downloadBillRoute = (invoiceNumber: number, accountId: string) =>
    `${getEndpoint(BILLING_MS_NAME)}invoices/${invoiceNumber}?accountId=${accountId}`;

export const getBillHistoryRoute = (accountId: string) =>
    `${getEndpoint(BILLING_MS_NAME)}accounts/${accountId}/invoices`;
